import Handlebars from "handlebars";
import downloadFiles from "@/services/download-files";

var ampScriptInvocationlTemplate = Handlebars.compile(`%%[
    set @triggerkey = "{{data.properties.trigger_properties.external_key}}"
    set @{{emailAddressField.field_name_clean}} = queryparameter("{{emailAddressField.field_name}}")
    set @{{subscriberKeyField.field_name_clean}} = queryparameter("{{subscriberKeyField.field_name}}"){{#each attributes}}
    set @{{field_name_clean}} = queryparameter("{{field_name}}"){{/each}}
    
    
    IF IsEmailAddress(@{{de_field_email.name_clean}}) THEN
        /* Invoke the trigger */
        VAR @ts, @tsDef, @ts_sub, @ts_attrts_subkey, @ts_statusCode, @ts_statusMsg, errorCode
    
        SET @ts = CreateObject("TriggeredSend")
        SET @tsDef = CreateObject("TriggeredSendDefinition")
    
        SetObjectProperty(@tsDef, "CustomerKey", @triggerkey)
        SetObjectProperty(@ts, "TriggeredSendDefinition", @tsDef)
    
        SET @ts_sub = CreateObject("Subscriber")
        SetObjectProperty(@ts_sub, "EmailAddress", @{{emailAddressField.field_name_clean}})
        SetObjectProperty(@ts_sub, "SubscriberKey", @{{subscriberKeyField.field_name_clean}}){{#each attributes}}
    
        SET @ts_attr = CreateObject("Attribute")
        SetObjectProperty(@ts_attr, "Name", "{{field_name}}")
        SetObjectProperty(@ts_attr, "Value", @{{field_name_clean}})
        AddObjectArrayItem(@ts_sub, "Attributes", @ts_attr){{/each}}
    
        AddObjectArrayItem(@ts, "Subscribers", @ts_sub)
    
        SET @ts_statusCode = InvokeCreate(@ts, @ts_statusMsg, @errorCode)	
    ENDIF
    ]%%
    {
        "statusCode": "%%=v(Replace(Replace(Replace(@ts_statusCode, '"', ''), char(13), ''), char(10), ''))=%%",
        "statusMsg": "%%=v(Replace(Replace(Replace(@ts_statusMsg, '"', ''), char(13), ''), char(10), ''))=%%",
        "errorCode": "%%=v(Replace(Replace(Replace(@errorCode, '"', ''), char(13), ''), char(10), ''))=%%"
    }`);

// eslint-disable-next-line
var make = function(data, form, component) {
    var attributes = [];
    var emailAddressField, subscriberKeyField;
    data.dataExtension.forEach((field) => {
        field["field_name_clean"] = field["field_name"].replace(/\s+/, "_").replace(/_+/, "_");
        if (field["field_name"] == "EmailAddress") {
            emailAddressField = field;
        } else if (field["field_name"] == "SubscriberKey") {
            subscriberKeyField = field;
        } else {
            attributes.push(field);
        }
    });
    return (
        ampScriptInvocationlTemplate({
            data: data,
            attributes: attributes,
            emailAddressField: emailAddressField,
            subscriberKeyField: subscriberKeyField
        })
    );
};
export default function(triggers, form, component) {
    var samples = [];
    triggers.forEach((trigger) => {
        samples.push({
            name: `${trigger.data.properties.trigger_properties.name}.AMPScript_Invocation.json`,
            content: make(trigger.data, form, component),
            type: "text/plain;charset=utf-8"
        });
    });
    return downloadFiles(samples, "AMPScript_Invocation.zip");
}